import { JSX } from 'solid-js';

export const mouseScrollIcon = (): JSX.Element => (
  <svg
    width="13px"
    height="20px"
    viewBox="0 0 10 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.67417 15C2.09682 15 0 12.9032 0 10.3258V4.67418C0 2.09682 2.09682 0 4.67417 0C7.25153 0 9.34836 2.09682 9.34836 4.67418V10.3258C9.34836 12.9032 7.25153 15 4.67417 15ZM4.67417 0.849972C2.56531 0.849972 0.849634 2.56564 0.849634 4.67451V10.3262C0.849634 12.435 2.56531 14.1507 4.67417 14.1507C6.78304 14.1507 8.49872 12.435 8.49872 10.3262V4.67451C8.49872 2.56564 6.78304 0.849972 4.67417 0.849972Z"
      fill="currentColor"
    />
    <path
      d="M4.60122 6.85949C4.52594 6.85949 4.45412 6.82739 4.40378 6.77128L3.71515 6.00251C3.61746 5.89351 3.6267 5.72586 3.7357 5.62818C3.8447 5.53049 4.01235 5.53973 4.11004 5.64873L4.60122 6.19719L5.09241 5.64873C5.19009 5.53973 5.35775 5.53049 5.46675 5.62818C5.57575 5.72586 5.58498 5.89351 5.4873 6.00251L4.79867 6.77128C4.74833 6.82739 4.67674 6.85949 4.60122 6.85949Z"
      fill="currentColor"
    />
    <path
      d="M4.60122 3.34644C4.67651 3.34644 4.74833 3.37854 4.79867 3.43465L5.4873 4.20342C5.58498 4.31242 5.57575 4.48007 5.46675 4.57775C5.35775 4.67544 5.19009 4.6662 5.09241 4.5572L4.60122 4.00874L4.11004 4.5572C4.01235 4.6662 3.8447 4.67544 3.7357 4.57775C3.6267 4.48007 3.61746 4.31242 3.71515 4.20342L4.40378 3.43465C4.45412 3.37854 4.52571 3.34644 4.60122 3.34644Z"
      fill="currentColor"
    />
  </svg>
);

export const leftClickIcon = (): JSX.Element => (
  <svg
    width="13px"
    height="20px"
    viewBox="0 0 10 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.67418 0C2.09682 0 0 2.09682 0 4.67418V10.3258C0 12.9032 2.09682 15 4.67418 15C7.25153 15 9.34836 12.9032 9.34836 10.3258V4.67418C9.34836 2.09682 7.25153 0 4.67418 0ZM8.49872 10.3258C8.49872 12.4347 6.78305 14.1504 4.67418 14.1504C2.56531 14.1504 0.849638 12.4347 0.849638 10.3258V6.13218H4.67418V5.2715C4.3807 5.2715 4.14311 5.03358 4.14311 4.74044V4.03402C4.14311 3.74055 4.38104 3.50296 4.67418 3.50296V0.849972C6.78305 0.849972 8.49872 2.56564 8.49872 4.67451V10.3262V10.3258Z"
      fill="currentColor"
    />
    <path
      d="M5.20538 4.74016V4.03375C5.20538 3.74028 4.96746 3.50269 4.67432 3.50269V5.27156C4.96779 5.27156 5.20538 5.03364 5.20538 4.7405V4.74016Z"
      fill="currentColor"
    />
  </svg>
);

export const rightClickIcon = (): JSX.Element => (
  <svg
    width="13px"
    height="20px"
    viewBox="0 0 10 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4.67418V10.3258C0 12.9032 2.09682 15 4.67418 15C7.25154 15 9.34836 12.9032 9.34836 10.3258V4.67418C9.34836 2.09682 7.25154 0 4.67418 0C2.09682 0 0 2.09682 0 4.67418ZM0.849638 6.13218V4.67451C0.849638 2.56564 2.56531 0.849972 4.67418 0.849972V3.50262C4.96765 3.50262 5.20525 3.74055 5.20525 4.03369V4.7401C5.20525 5.03358 4.96732 5.27117 4.67418 5.27117V6.13185H8.49872V10.3255C8.49872 12.4344 6.78305 14.15 4.67418 14.15C2.56531 14.15 0.849638 12.4344 0.849638 10.3255V6.13185V6.13218Z"
      fill="currentColor"
    />
    <path
      d="M4.14319 4.74016V4.03375C4.14319 3.74028 4.38111 3.50269 4.67425 3.50269V5.27156C4.38078 5.27156 4.14319 5.03364 4.14319 4.7405V4.74016Z"
      fill="currentColor"
    />
  </svg>
);
